(function(){
  "use strict";

  angular.module('irricrops')
  .controller("cuartelCtrl", [
    function(){

    }]);
})();
